import Button from 'components/buttons/Button';
import { COLOR } from 'const/color';
import dayjs, { Dayjs } from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import 'pages/shift/AddCourierModal/AddCourierModal.scss';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { MdClose } from 'react-icons/md';
import analyticsWrapper from '../../../../../utils/analyticsWrapper';
import { Link } from 'react-router-dom';
import { ButtonComponent } from '../../../../../ReusableComponents/Button/ButtonComponent';
import { FaWrench } from 'react-icons/fa';
import { useGetInboundInfoForPickups } from 'hooks/useGetInboundInfoForPickups';
import { InboundInfo } from '../../../../../fetch/fetchInbound';
import { OrdersAccountCount } from '../../../../../types/statsTypes';

dayjs.extend(isoWeek);

export const ExtraListName = `Extra list`;

function InboundShopBox({
  selectedInboundShopList,
  inboundShop,
  setSelectedInboundShopList,
}: {
  selectedInboundShopList: OrdersAccountCount[];
  inboundShop: OrdersAccountCount;
  setSelectedInboundShopList: (
    selectedInboundShopList: OrdersAccountCount[]
  ) => void;
}) {
  const [inboundShopTextCopied, setInboundShopTextCopied] =
    useState<boolean>(false);

  const removeSelectedFromList = (removeThisId: number) => {
    const newList = selectedInboundShopList.filter(
      inboundShop => inboundShop.accountId !== removeThisId
    );
    setSelectedInboundShopList(newList);
  };

  const userPhoneCopyMethod = () => {
    setInboundShopTextCopied(true);
    setTimeout(() => setInboundShopTextCopied(false), 2500);
  };

  const IsSelected: boolean =
    selectedInboundShopList &&
    selectedInboundShopList.length > 0 &&
    selectedInboundShopList
      .map(
        (selectedInboundShop: OrdersAccountCount) =>
          selectedInboundShop.accountId
      )
      .indexOf(inboundShop.accountId) !== -1;

  return (
    <button
      className="courierNameButton"
      style={{
        backgroundColor: IsSelected && COLOR.SHIFT_GREEN,
        color: IsSelected && COLOR.WHITE,
      }}
    >
      <div
        className="nameButton"
        onClick={e => {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(
              `${inboundShop.accountName} ${inboundShop.orderCount}`
            );
            userPhoneCopyMethod();
            analyticsWrapper.event({
              category: 'inBoundShop-modal',
              action: `copy-1-shop-Btn ${inboundShop.accountName}`,
              label: 'click',
            });
          }
        }}
      >
        {`${inboundShop.accountName} ${inboundShop.orderCount}`}
      </div>
      {inboundShopTextCopied && (
        <div>
          {`copied! ${inboundShop.accountName} ${inboundShop.orderCount}`}
        </div>
      )}
      {IsSelected && (
        <div
          className="exit-sign-in-button"
          onClick={() => removeSelectedFromList(inboundShop.accountId)}
        >
          <MdClose />
        </div>
      )}
    </button>
  );
}

function ShowByType({
  inboundShopList,
  selectedInboundShopList,
  setSelectedInboundShopList,
  title,
}: {
  inboundShopList: OrdersAccountCount[];
  selectedInboundShopList: OrdersAccountCount[];
  setSelectedInboundShopList: Dispatch<SetStateAction<OrdersAccountCount[]>>;
  title: string;
}): JSX.Element {
  return (
    <>
      {inboundShopList.length > 0 && (
        <div className="groupCouriersList">
          <div className="travelMode-title">
            {`${title}`}
            <CopyAllInboundShopsButton
              inboundShopList={inboundShopList}
              title="Copy all"
            />{' '}
          </div>

          <div className="add-courier-search-box">
            {inboundShopList.map(
              (inboundShop: OrdersAccountCount, index: number) => (
                <InboundShopBox
                  key={index}
                  selectedInboundShopList={selectedInboundShopList}
                  inboundShop={inboundShop}
                  setSelectedInboundShopList={setSelectedInboundShopList}
                />
              )
            )}
          </div>
        </div>
      )}
    </>
  );
}

function CopyAllInboundShopsButton({
  inboundShopList,
  title,
}: {
  inboundShopList: OrdersAccountCount[];
  title: string;
}) {
  const [clicked, setClicked] = useState(false);

  const CopyToClipBoard = () => {
    setClicked(true);
    setTimeout(() => setClicked(false), 2500);
  };

  return (
    <Button
      style={{
        marginLeft: '10px',
        backgroundColor: clicked && COLOR.SHIFT_GREEN,
      }}
      onClick={e => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          const inboundShopListArray: string[] = inboundShopList.map(
            (inboundShop: OrdersAccountCount, index: number) => {
              return `${'\n'}  🏭-${inboundShop.accountName} - ${
                inboundShop.orderCount
              }📦 `;
            }
          );
          const inboundShopListIntroString =
            'Today you should drive and pickup at the following shops:  ';

          const inboundShopListString = inboundShopListArray.join(' ');

          const totalInboundShopListString = inboundShopListIntroString.concat(
            inboundShopListString
          );

          navigator.clipboard.writeText(totalInboundShopListString);
          CopyToClipBoard();
          analyticsWrapper.event({
            category: 'inBoundShop-modal',
            action: `copy-all-btn`,
            label: 'click',
          });
        }
      }}
      title={clicked ? 'Copied to clipboard' : title}
    ></Button>
  );
}

function getFilteredInboundList(
  inboundShopList: OrdersAccountCount[],
  driverName: string,
  accountIdList: number[]
): OrdersAccountCount[] {
  const filteredInboundList = inboundShopList.filter(
    obj => accountIdList.indexOf(obj.accountId) !== -1
  );

  return filteredInboundList;
}

export function SmsInboundModal({
  date,
  closeModal,
  inboundShopList,
}: {
  date: Dayjs;
  closeModal: () => void;
  inboundShopList: OrdersAccountCount[];
}): JSX.Element {
  const [selectedInboundShopList, setSelectedInboundShopList] =
    useState<OrdersAccountCount[]>(null);

  const { inboundInfoList, isLoading } = useGetInboundInfoForPickups();

  return (
    <div className="shift-modal_add-courier-modal">
      <div className="shift-modal-box">
        <div className="modal-header">
          <div className="topHeaderRow">
            <div className="title">
              {`Inbound pickups for ${dayjs(date).format('DD/MM')}`}
            </div>

            <div className="exit-sign" onClick={() => closeModal()}>
              <MdClose />
            </div>
          </div>
        </div>

        {!isLoading && (
          <InboundList
            inboundInfoList={inboundInfoList}
            inboundShopList={inboundShopList}
            selectedInboundShopList={selectedInboundShopList}
            setSelectedInboundShopList={setSelectedInboundShopList}
          />
        )}

        <div className="modal-footer">
          <ButtonComponent
            component={Link}
            to="/dashboard/inbound-info"
            variant="outlined"
            startIcon={<FaWrench />}
            onClick={() => {
              analyticsWrapper.event({
                category: 'inBound-config',
                action: `click-from-modal`,
                label: 'click',
              });
            }}
          >
            {'Edit inbound info'}
          </ButtonComponent>
        </div>
      </div>
    </div>
  );
}

function InboundList({
  inboundInfoList,
  inboundShopList,
  selectedInboundShopList,
  setSelectedInboundShopList,
}: {
  inboundInfoList: InboundInfo[];
  inboundShopList: OrdersAccountCount[];
  selectedInboundShopList: OrdersAccountCount[];
  setSelectedInboundShopList: Dispatch<SetStateAction<OrdersAccountCount[]>>;
}) {
  const newList: OrdersAccountCount[][] = inboundInfoList
    .sort((a: InboundInfo, b: InboundInfo) => {
      if (a.name > b.name) {
        return 1;
      } else if (a.name < b.name) {
        return -1;
      } else {
        return 0;
      }
    })
    .map(obj => {
      const shopName = obj.name;
      const accountIdList = obj.account_ids;
      return getFilteredInboundList(inboundShopList, shopName, accountIdList);
    });

  const EveryRegisteredIds: number[] = newList
    .map(list => list.map(obj => obj.accountId).flat())
    .flat();

  const extraList = inboundShopList.filter(
    obj => EveryRegisteredIds.indexOf(obj.accountId) === -1
  );

  return (
    <div className="modal-page">
      <div className="modal-content">
        {extraList && extraList.length > 0 && (
          <ShowByType
            inboundShopList={extraList}
            selectedInboundShopList={selectedInboundShopList}
            setSelectedInboundShopList={setSelectedInboundShopList}
            title={ExtraListName}
          />
        )}
        {newList.map((list, index) => {
          return (
            <ShowByType
              key={`${inboundInfoList[index].name}`}
              inboundShopList={list}
              selectedInboundShopList={selectedInboundShopList}
              setSelectedInboundShopList={setSelectedInboundShopList}
              title={`${inboundInfoList[index].name}`}
            />
          );
        })}
      </div>
    </div>
  );
}
